/** dialogue module entry (owner: story-builder). */
import type { IDialogueBox } from '@/core/types/contracts';
import { SHOWCASES } from '@/content/ShowcaseScene';
import { DialogueRunner, type DialogueHooks, type DialogueRunnerOptions } from './DialogueRunner';
import { runDialogueShowcase } from './showcase/DialogueShowcase';

export { DIALOGUES, registerDialogues, getDialogue } from './registry';
export { DialogueRunner, hooksFromContext } from './DialogueRunner';
export type { DialogueHooks, DialogueHost, DialogueRunnerOptions, DialoguePhase } from './DialogueRunner';
export { evalCondition } from './conditions';
export type { ConditionEnv } from './conditions';
export { textHash, readMarkFor, isReadMark, READ_MARK_PREFIX } from './hash';
export { DevDialogueBox, resolveDialogueBox, DIALOGUE_FONT } from './DevDialogueBox';
export type { DevDialogueBoxOptions } from './DevDialogueBox';

/** Creates the runner. `opts.host` adds emote/face/sfx presentation hooks. */
export function createDialogueRunner(box: IDialogueBox, hooks: DialogueHooks, opts: DialogueRunnerOptions = {}): DialogueRunner {
  return new DialogueRunner(box, hooks, opts);
}

/** Registers `?showcase=dialogue`. Called by the integrator from main.ts. */
export function registerShowcase(): void {
  SHOWCASES['dialogue'] = runDialogueShowcase;
}
